module.exports = __webpack_public_path__ + "media/newstyle/images/globe_book-96ee65c1d0faea0a030f75f2acac204e.svg";